export const GET_OPERATIONS_LIST_API = "/api/operations/list";
export const GET_OPERATIONS_REPORT_API = "/api/operations/report";
//export const EDIT_CARD_API = "/api/cards/edit";
//export const ADD_CARD_API = "/api/cards/add";